import { Box } from '@mui/material';
import Params from '../../../Types/ParamsPicklist';
import SearchModal from '../../SearchModal';
import { Form } from 'antd';
import CheckboxF from '../../ChexBox';


const Tab2 = (props: { form?: any }) => {


let searchCaodeArete: Params = { CodeAgence: '', Table: "ARRETE", Colonne1: "CODARR", Colonne2: "LIBELLE1", Colagence: '', Choix: 22 }
let searchAgiosImpeye: Params = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '', Choix: 22 }
let searchOpe: Params = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
//let searchOpe: Params = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '', Choix: 22 }
//let searchAgiosImpeye: Params = { CodeAgence: props.Numcli ? props.Numcli : "JH", Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "NUMCLI", Choix: 22 }

  return (
     <div className='tabItem'>
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        <Box display={'inline-flex'}>
          <SearchModal notRequired form={props.form} width={9} Titre={"recherche Code Arrété"} label={"Code Arrété"} name={"ICARCP"} Parametre={searchCaodeArete} />
          <SearchModal notRequired form={props.form} width={9} Titre={"recherche Agios Impayés"} label={"Agios Impayés"} name={"CPTAGIOSIMP"} Parametre={searchAgiosImpeye} />
        </Box>

        <Box style={{ display: 'flex' }}   >
          <Box fontStyle="inherit" className='border-left '>
            {/* <Typography align='left'> Type Intérèt</Typography> */}
            <CheckboxF name='CALINT' label='Calcul Interet' />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Interet"} label={""} name={"TYPIN1"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Interet"} label={""} name={"TYPIN2"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Interet"} label={""} name={"TYPIN3"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Interet"} label={""} name={"TYPIN4"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Interet"} label={""} name={"TYPIN5"} Parametre={searchOpe} />
          </Box>

          <Box fontStyle="inherit" className='border-left '>
            <CheckboxF name='CALCOM' label='Calcul Commission' />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={"TYPCO1"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={"TYPCO2"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={"TYPCO3"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={"TYPCO4"} Parametre={searchOpe} />
            <SearchModal notRequired form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={"TYPCO5"} Parametre={searchOpe} />
          </Box>
        </Box>

        {/*
        <Box fontStyle="inherit" className='border-left '>
              <CheckboxF name='calcomsp' label='Commission Spéciale?' />
              <Form.Item label='' />
              <SearchModal form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={""} Parametre={searchCaodeArete} />
              <SearchModal form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={""} Parametre={searchCaodeArete} />
              <SearchModal form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={""} Parametre={searchCaodeArete} />
              <SearchModal form={props.form} width={9} Titre={"recherche Calcul Commission"} label={""} name={""} Parametre={searchCaodeArete} />
            </Box> 
        */}

      </Box>

    </div>

  );

}

export default Tab2;